import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { api } from '../../../static/api';
import { getApiErrorMessage } from '../../../utils/api/getApiErrorMessage';
import useAxiosInstance from '../../axios/useAxiosInstance';
import useToast from '../../useToast';

const useRequestResetPassword = () => {
  const axiosInstance = useAxiosInstance();
  const { showErrorToast } = useToast();
  const { t } = useTranslation();

  const { mutateAsync, isLoading, isSuccess } = useMutation(
    ({ email }: { email: string }) => axiosInstance.post(api.endpoints.REQUEST_RESET_PASSWORD, { email }),
    {
      onError: (err: AxiosError) => {
        const errorMessage = getApiErrorMessage(err) ?? t('errorMessages.requestResetPasswordFailed');

        showErrorToast(errorMessage);
      },
    },
  );

  return { requestResetPassword: mutateAsync, isLoading, isSuccess };
};

export default useRequestResetPassword;
